var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { padding: "0 20px", background: "#fff" } },
    [
      _c(
        "a-tabs",
        {
          attrs: { activeKey: _vm.activeKey, destroyInactiveTabPane: "" },
          on: { change: _vm.changeTab },
        },
        [
          _vm._l(_vm.tabList, function (item, index) {
            return _c(
              "a-tab-pane",
              { key: item.key, attrs: { tab: item.tab } },
              [
                item.key !== "16"
                  ? _c("CollapseResource", {
                      attrs: {
                        title: `${item.key === "4" ? "工作手册" : "课题研究"}`,
                        actionUrl: item.url,
                        sortDictCode: "research_sort",
                        actionType: item.key,
                      },
                    })
                  : _c("SchemeCard", {
                      ref: "schemeCardRef",
                      refInFor: true,
                      attrs: {
                        actionUrl: item.url,
                        activeKey: item.key,
                        keysFormArr: item.keysFormArr,
                        cateDictCode: item?.cateDictCode,
                      },
                    }),
              ],
              1
            )
          }),
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeKey === "16",
                  expression: "activeKey === '16'",
                },
              ],
              attrs: { slot: "tabBarExtraContent", type: "primary" },
              on: { click: _vm.createLeague },
              slot: "tabBarExtraContent",
            },
            [_vm._v("\n      创建\n    ")]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }